module.exports = __webpack_public_path__ + "android-icon-96x96.png?7bbf9ba57f5769b737ca4f08f28753de";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/android-icon-96x96.png
// module id = 126
// module chunks = 0